"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportTypesCodes = exports.backendReportTypesCodes = exports.ReportTypeService = void 0;
var _reportType = require("../models/report-type");
var _http = require("./http");
class ReportTypeService {
  static async getReportTypes() {
    try {
      const data = await _http.HttpService.get('v2', '/report_types');
      const _reportTypesMap = data.reduce((res, typeData) => {
        const type = parseReportType(typeData);
        if (type) res[type.code] = type;
        return res;
      }, {});
      return _reportType.reportParentsCodes.map(parentKey => {
        const {
          isBindToOSM,
          children
        } = _reportType.reportTypesChildren[parentKey];
        return new _reportType.ReportType(-1, parentKey, isBindToOSM, _reportType.reportTypesTitleKeys[parentKey], children.reduce((res, childKey) => {
          const child = _reportTypesMap[childKey];
          if (child) res.push(child);
          return res;
        }, []));
      });
    } catch (err) {
      console.error('[ReportTypeService][getReportTypes]', err);
      return [];
    }
  }
}
exports.ReportTypeService = ReportTypeService;
const reportTypesCodes = exports.reportTypesCodes = {
  DUSTBIN: 'dustbin',
  GCUM: 'gcum',
  POLE: 'pole',
  ADVERTISING: 'advertising',
  TREE: 'tree',
  VEGETATION: 'vegetation',
  BARRIER: 'barrier',
  THEFT: 'theft',
  BICYCLE_DAMMAGE: 'bicycleDammage',
  KERB: 'kerb',
  DANGEROUS_EXIT: 'dangerousExit',
  DANGEROUS_CROSSING: 'dangerousCrossing',
  PARKING_NEAR_CYCLEWAY: 'parkingNearCycleway',
  NO_MARKING: 'noMarking',
  NO_LIGHTING: 'noLighting',
  BLIND_SPOT: 'blindSpot',
  POTHOLE: 'pothole',
  MARKING_ERASED: 'markingErased',
  PEBBLES: 'pebbles',
  BROKEN_GLASS: 'brokenGlass',
  DEAD_LEAVES: 'deadLeaves',
  ROOTS: 'roots',
  DANGEROUS: 'dangerous',
  ACCIDENT: 'accident',
  ROAD_BLOCKED: 'roadBlocked',
  POLICE_PRESENCE: 'policePresence',
  HEAVY_BICYCLE_TRAFFIC: 'heavyBicycleTraffic',
  HEAVY_CAR_TRAFFIC: 'heavyCarTraffic',
  HEAVY_PEDESTRIAN_TRAFFIC: 'heavyPedestrianTraffic',
  SNOW: 'snow',
  FREEZING_RAIN: 'freezingRain',
  FLOOD: 'flood',
  BIKE_FACILITY: 'bikeFacility',
  BIKE_PARKING_STANDS: 'bikeParkingStands',
  BIKE_PARKING_WALL_LOOP: 'bikeParkingWallLoop',
  BIKE_PARKING_SHED: 'bikeParkingShed',
  BIKE_PARKING_BOLLARD: 'bikeParkingBollard',
  BIKE_PARKING_LOCKERS: 'bikeParkingLockers',
  BIKE_PARKING: 'bikeParking',
  UNLISTED_BICYCLE_REPAIR: 'unlistedBicycleRepair',
  UNLISTED_CHARGING_STATION: 'unlistedChargingStation',
  UNLISTED_WATER_POINT: 'unlistedWaterPoint',
  UNLISTED_TOILETS: 'unlistedToilets',
  UNLISTED_PICNIC_AREA: 'unlistedPicnicArea',
  UNLISTED_BICYCLE_PUMP: 'unlistedWaterPoint',
  CARTOGRAPHIC_ISSUE: 'cartographicIssue',
  BICYCLE_FACILITY_REQUEST: 'bicycleFacilityRequest',
  BICYCLE_PARKING_REQUEST: 'bicycleParkingRequest',
  SUPPORT_LOCAL_AUTHORITIES: 'supportLocalAuthorities',
  EXCLUSION_ZONE: 'exclusionZone',
  TO_DO_TO_SEE: 'toDoToSee',
  ROADWORK: 'roadwork',
  SUPPORT: 'support'
};
const backendReportTypesCodes = exports.backendReportTypesCodes = {
  obstacles: ['DUSTBIN', 'GCUM', 'POLE', 'ADVERTISING', 'TREE', 'VEGETATION', 'BARRIER'],
  dustbin: 'DUSTBIN',
  gcum: 'GCUM',
  pole: 'POLE',
  advertising: 'ADVERTISING',
  tree: 'TREE',
  vegetation: 'VEGETATION',
  barrier: 'BARRIER',
  incivilities: ['THEFT', 'BICYCLE_DAMMAGE'],
  theft: 'THEFT',
  bicycleDammage: 'BICYCLE_DAMMAGE',
  faultyFacilities: ['KERB', 'DANGEROUS_EXIT', 'DANGEROUS_CROSSING', 'PARKING_NEAR_CYCLEWAY', 'NO_MARKING', 'NO_LIGHTING', 'BLIND_SPOT'],
  kerb: 'KERB',
  dangerousExit: 'DANGEROUS_EXIT',
  dangerousCrossing: 'DANGEROUS_CROSSING',
  parkingNearCycleway: 'PARKING_NEAR_CYCLEWAY',
  noMarking: 'NO_MARKING',
  noLighting: 'NO_LIGHTING',
  blindSpot: 'BLIND_SPOT',
  needMaintenance: ['POTHOLE', 'MARKING_ERASED', 'PEBBLES', 'BROKEN_GLASS', 'DEAD_LEAVES', 'ROOTS'],
  pothole: 'POTHOLE',
  markingErased: 'MARKING_ERASED',
  pebbles: 'PEBBLES',
  brokenGlass: 'BROKEN_GLASS',
  deadLeaves: 'DEAD_LEAVES',
  roots: 'ROOTS',
  dangerous: 'DANGEROUS',
  accident: 'ACCIDENT',
  roadBlocked: 'ROAD_BLOCKED',
  policePresence: 'POLICE_PRESENCE',
  traffic: ['HEAVY_BICYCLE_TRAFFIC', 'HEAVY_CAR_TRAFFIC', 'HEAVY_PEDESTRIAN_TRAFFIC'],
  heavyBicycleTraffic: 'HEAVY_BICYCLE_TRAFFIC',
  heavyCarTraffic: 'HEAVY_CAR_TRAFFIC',
  heavyPedestrianTraffic: 'HEAVY_PEDESTRIAN_TRAFFIC',
  badWeather: ['SNOW', 'FREEZING_RAIN', 'FLOOD'],
  snow: 'SNOW',
  freezingRain: 'FREEZING_RAIN',
  flood: 'FLOOD',
  bikeFacility: 'BIKE_FACILITY',
  bikeParkings: ['BIKE_PARKING_STANDS', 'BIKE_PARKING_WALL_LOOP', 'BIKE_PARKING_SHED', 'BIKE_PARKING_BOLLARD', 'BIKE_PARKING_LOCKERS', 'BIKE_PARKING'],
  bikeParkingStands: 'BIKE_PARKING_STANDS',
  bikeParkingWallLoop: 'BIKE_PARKING_WALL_LOOP',
  bikeParkingShed: 'BIKE_PARKING_SHED',
  bikeParkingBollard: 'BIKE_PARKING_BOLLARD',
  bikeParkingLockers: 'BIKE_PARKING_LOCKERS',
  bikeParking: 'BIKE_PARKING',
  unlistedBicycleService: ['UNLISTED_BICYCLE_REPAIR', 'UNLISTED_CHARGING_STATION', 'UNLISTED_WATER_POINT', 'UNLISTED_TOILETS', 'UNLISTED_PICNIC_AREA', 'UNLISTED_BICYCLE_PUMP'],
  unlistedBicycleRepair: 'UNLISTED_BICYCLE_REPAIR',
  unlistedChargingStation: 'UNLISTED_CHARGING_STATION',
  unlistedWaterPoint: 'UNLISTED_WATER_POINT',
  unlistedToilets: 'UNLISTED_TOILETS',
  unlistedPicnicArea: 'UNLISTED_PICNIC_AREA',
  unlistedBicyclePump: 'UNLISTED_BICYCLE_PUMP',
  cartographicIssue: 'CARTOGRAPHIC_ISSUE',
  bicycleFacilityRequest: 'BICYCLE_FACILITY_REQUEST',
  bicycleParkingRequest: 'BICYCLE_PARKING_REQUEST',
  supportLocalAuthorities: 'SUPPORT_LOCAL_AUTHORITIES',
  exclusionZone: 'EXCLUSION_ZONE',
  toDoToSee: 'TO_DO_TO_SEE',
  roadwork: 'ROADWORK',
  support: 'SUPPORT'
};
function parseReportType({
  id,
  code: _code,
  is_bind_to_osm: isBindToOSM
}) {
  const code = reportTypesCodes[_code];
  if (!code) return null;
  return new _reportType.ReportType(id, code, isBindToOSM, _reportType.reportTypesTitleKeys[code], []);
}